// eslint-disable-next-line import/no-restricted-paths
import { AccordionTrigger, type AccordionSingleProps } from "@radix-ui/react-accordion";
import { memo, useCallback, useState } from "react";

import { cn } from "@/lib/chillnn/cn";
import type { HotelTopQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { Accordion, AccordionContent, AccordionItem } from "@/components/ui/accordion/accordion";
import { buttonVariants } from "@/components/ui/button/button";

import { Manual } from "./manual";
import { TodoList } from "./todo-list";

type Props = {
	startGuide: HotelTopQuery["startGuide"];
	hotelTemplateSettings: HotelTopQuery["hotelTemplateSettings"];
	hotelUrls: HotelTopQuery["hotelUrls"];
	hotelID: string;
	isTestReservationAvailable: boolean;
};

const ACCORDION_ITEM_ID_0 = "HotelTopIslandStartGuide_0";

export const IslandStartGuide = memo(
	({ startGuide, hotelTemplateSettings, hotelUrls, hotelID, isTestReservationAvailable }: Props) => {
		const [value, setValue] = useState<AccordionSingleProps["value"]>(
			// 予約が存在しない場合は、販売スタートガイドを開く
			startGuide.isReservationExists ? undefined : ACCORDION_ITEM_ID_0,
		);
		const handleValueChange = useCallback((value: AccordionSingleProps["value"]) => {
			setValue(value);
		}, []);

		return (
			<FeatureIslandMainWithBackGround>
				<Accordion type="single" collapsible value={value} onValueChange={handleValueChange}>
					<AccordionItem value={ACCORDION_ITEM_ID_0} borderBottom={false}>
						<AccordionTrigger className="group w-full">
							<div className="flex w-full items-center justify-between">
								<h3 className="text-lg font-semibold">販売スタートガイド</h3>

								{/* AccordionTrigger が <button> で定義されており、<button> 同士をネストして定義はできないので、見た目だけボタンに寄せている */}
								<div className={cn(buttonVariants({ variant: "outline", size: "lg" }))}>
									{value ? "閉じる" : "開く"}
								</div>
							</div>
						</AccordionTrigger>

						<AccordionContent>
							<div className="my-10 space-y-8 lg:mx-4">
								<Manual />
								<TodoList
									startGuide={startGuide}
									hotelTemplateSettings={hotelTemplateSettings}
									hotelUrls={hotelUrls}
									hotelID={hotelID}
									isTestReservationAvailable={isTestReservationAvailable}
								/>
							</div>
						</AccordionContent>
					</AccordionItem>
				</Accordion>
			</FeatureIslandMainWithBackGround>
		);
	},
);
